export default "__VITE_ASSET__BnWOe0Qy__"